import * as Yup from 'yup';
import { APLHABET_PATTERN_REGEX, MOBILE_NUMBER_REGEX, ROLES } from '../constants/common';

export const addEditInterviewerSchema = Yup.object({
  firstName: Yup.string()
    .trim()
    .max(15, 'Must be 15 characters or less')
    .min(3, 'Must be 3 characters or more.')
    .matches(APLHABET_PATTERN_REGEX, 'First name should only contain alphabetical characters.')
    .required('First Name is required.'),
  lastName: Yup.string()
    .trim()
    .max(20, 'Must be 20 characters or less')
    .min(3, 'Must be 3 characters or more.')
    .matches(APLHABET_PATTERN_REGEX, 'Last name should only contain alphabetical characters.')
    .required('Last Name is required.'),
  email: Yup.string()
    .trim()
    .email('Enter a valid email address')
    .required('Email Address is required.'),
  pmEmail: Yup.string()
    .trim()
    .email('Enter a valid email address')
    .when(['userTypeId'], {
      is: (value) => value === ROLES.INTERVIEWER,
      then: Yup.string().required('Email Address is required.'),
      otherwise: Yup.string()
    }),
  mobile: Yup.string().matches(MOBILE_NUMBER_REGEX, 'Mobile Number Must Be 10 Digits Only.'),
  gender: Yup.string(['1', '2']).required('Gender is required.'),
  isPracticalAllow: Yup.boolean(),
  isPracticalAdmin: Yup.boolean(),
  yearOfExperience: Yup.number()
    .min(0, 'Minimum 0 Year.')
    .max(100, 'Maximum 100 Years.')
    .typeError('Only numbers are allowed.')
    .required('Exp. in Years is Required.'),
  monthsOfExperience: Yup.number()
    .min(0, 'Minimum 0 Month.')
    .max(11, 'Maximum 11 Months.')
    .required('Exp. in Months is required.')
    .typeError('Only numbers are allowed.'),
  skills: Yup.array()
    .of(Yup.string('Should be of type string.'))
    .min(1, 'Please select at least one skill.')
    .required('Skills are required.')
});
